// IMPORT PACKAGE REFERENCES

import React, { Fragment } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES

import { Header } from '../Header/Header';
import { Footer } from '../Header/Footer';
import { HomePage } from '../Pages/HomePage';
import { AboutPage } from '../Pages/AboutPage';
import { DeviceListPage } from '../Pages/Device/DeviceListPage';
import { PharmacyListPage } from '../Pages/Device/PharmacyListPage';
import { DevicePage } from '../Pages/Device/DevicePage';
import { PharmacyPage } from '../Pages/Device/PharmacyPage';
import { LoginPage } from '../Pages/LoginPage';
import { EventsPage } from '../Pages/EventsPage';
import PrivateRoute from './PrivateRoute';


// COMPONENT

class AppRouter extends React.Component {
    render() {
        return (
            <BrowserRouter>
                <Fragment>
                    <Header />    
                        <Switch>
                            <PrivateRoute loggedIn={this.props.loggedIn} path='/' component={HomePage} exact={true} />
                            <PrivateRoute loggedIn={this.props.loggedIn}  path="/pharmacies" component={PharmacyListPage} />
                            <PrivateRoute loggedIn={this.props.loggedIn}  path="/devices" component={DeviceListPage} />
                            <PrivateRoute loggedIn={this.props.loggedIn}  path="/device/:deviceId" component={DevicePage} />
                            <PrivateRoute loggedIn={this.props.loggedIn}  path="/pharmacy/:pharmacyId" component={PharmacyPage} />
                            <PrivateRoute loggedIn={this.props.loggedIn}  path="/events/:deviceId" component={EventsPage} />
                            <Route path='/about' component={AboutPage} />
                            <Route path='/login' component={LoginPage} />
                            <Redirect to="/" />
                        </Switch>
                    <Footer />
                </Fragment>
            </BrowserRouter>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn } = state.userReducer;
    return { loggedIn };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({}, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AppRouter);


// EXPORT COMPONENT

export { hoc as AppRouter };

